
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Skills() {
  const { t } = useTranslation();

  const skillCategories = [
    {
      title: t('skills.categories.frontend'),
      icon: 'ri-reactjs-line',
      color: 'bg-[#FFE5E5]',
      skills: ['React.js', 'Vue.js', 'Angular', 'Next.js', 'Nuxt.js', 'Tailwind CSS', 'Bootstrap', 'DaisyUI', 'HTML5/CSS3', 'TypeScript', 'SCSS']
    },
    {
      title: t('skills.categories.backend'),
      icon: 'ri-server-line',
      color: 'bg-[#E0F5F0]',
      skills: ['Node.js', 'Express.js', 'Laravel', 'Symfony', 'Flask', 'Spring Boot', 'ASP.NET']
    },
    {
      title: t('skills.categories.mobile'),
      icon: 'ri-smartphone-line',
      color: 'bg-[#FFF4E5]',
      skills: ['Flutter', 'Dart', 'Material UI', 'Cupertino', 'Provider', 'Riverpod', 'Bloc']
    },
    {
      title: t('skills.categories.database'),
      icon: 'ri-database-2-line',
      color: 'bg-[#F0F0F0]',
      skills: ['MongoDB', 'PostgreSQL', 'MySQL', 'Redis', 'SQLite', 'Prisma', 'Firebase']
    },
    {
      title: t('skills.categories.api'),
      icon: 'ri-cloud-line',
      color: 'bg-[#E8F4FF]',
      skills: ['REST API', 'GraphQL', 'Socket.io', 'JWT', 'Swagger', 'Axios']
    },
    {
      title: t('skills.categories.devops'),
      icon: 'ri-terminal-box-line',
      color: 'bg-[#F5E6D3]',
      skills: ['Docker', 'Kubernetes', 'Jenkins', 'GitLab CI/CD', 'GitHub Actions', 'CI/CD', 'Linux', 'Nginx']
    },
    {
      title: t('skills.categories.methodologies'),
      icon: 'ri-git-branch-line',
      color: 'bg-[#F0E8FF]',
      skills: ['Agile', 'Scrum', 'Kanban', 'MVC', 'MVVM', 'Clean Architecture', 'SOLID', 'Design Patterns', 'TDD']
    }
  ];

  return (
    <section id="skills" className="py-24 px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="mb-20">
          <h2 className="text-7xl font-black text-[#0A0A0A] leading-tight">
            {t('skills.title')}<br />{t('skills.subtitle')}
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          {skillCategories.map((category, index) => (
            <div
              key={index}
              className={`${category.color} rounded-[28px] p-10 transition-all duration-300 hover:shadow-xl hover:-translate-y-1 cursor-pointer`}
            >
              <div className="w-10 h-10 flex items-center justify-center mb-6">
                <i className={`${category.icon} text-4xl text-[#0A0A0A]`}></i>
              </div>
              <h3 className="text-2xl font-bold text-[#0A0A0A] mb-6">{category.title}</h3>
              <ul className="space-y-2.5">
                {category.skills.map((skill, idx) => (
                  <li key={idx} className="text-sm text-gray-700 leading-relaxed">
                    {skill}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-20 grid grid-cols-2 md:grid-cols-5 gap-8 text-center">
          <div>
            <div className="text-4xl font-bold text-[#0066FF]">JavaScript</div>
            <div className="text-sm text-gray-600 mt-2">{t('skills.languages.javascript')}</div>
          </div>
          <div>
            <div className="text-4xl font-bold text-[#0066FF]">TypeScript</div>
            <div className="text-sm text-gray-600 mt-2">{t('skills.languages.typescript')}</div>
          </div>
          <div>
            <div className="text-4xl font-bold text-[#0066FF]">Python</div>
            <div className="text-sm text-gray-600 mt-2">{t('skills.languages.python')}</div>
          </div>
          <div>
            <div className="text-4xl font-bold text-[#0066FF]">PHP</div>
            <div className="text-sm text-gray-600 mt-2">{t('skills.languages.php')}</div>
          </div>
          <div>
            <div className="text-4xl font-bold text-[#0066FF]">Dart</div>
            <div className="text-sm text-gray-600 mt-2">{t('skills.languages.dart')}</div>
          </div>
        </div>

        {/* CTA to detailed skills page */}
        <div className="text-center mt-16">
          <Link
            to="/skills"
            className="inline-flex items-center gap-3 bg-[#0A0A0A] text-white px-8 py-4 rounded-full font-semibold hover:bg-[#0066FF] transition-all duration-300 hover:gap-4 cursor-pointer whitespace-nowrap shadow-lg hover:shadow-xl"
          >
            {t('skills.viewAll')}
            <i className="ri-arrow-right-line text-xl"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}
